import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import UIAssetKeys from '../UIAssetKeys';
import LevelBase from './LevelBase';

export default class Level3 extends LevelBase {
  static get KEY() { return 'Level3'; }

  constructor() {
    super({ key: Level3.KEY });
  }

  init() {
    gameData.config.level = 3;

    super.init();
  }

  createNextScene () {
    super.createNextScene();

    const bg = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._7_Level_4_Lvl4_Bkgd, this.nextLvlCont).setOrigin(0);

    const coral1 = ABCyaPhaser.Images.addImage(-10, this.scale.height + 20, UIAssetKeys._7_Level_4_Lvl4_CoralLeft, this.nextLvlCont).setOrigin(0,1);
    const coral2 = ABCyaPhaser.Images.addImage(this.scale.width + 10, this.scale.height + 20, UIAssetKeys._7_Level_4_Lvl4_CoralRight, this.nextLvlCont).setOrigin(1);
  }
}